var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDepositsSolid = function SvgDepositsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm.75-10.417a2.084 2.084 0 0 1 1.766 1.042.75.75 0 1 1-1.3.75.583.583 0 0 0-.55-.292h-1.333a.583.583 0 0 0 0 1.167h1.334a2.083 2.083 0 0 1 .083 4.165V14a.75.75 0 0 1-1.5 0v-.583a2.083 2.083 0 0 1-1.766-1.043.75.75 0 1 1 1.3-.749.584.584 0 0 0 .55.292h1.333a.583.583 0 1 0 0-1.167h-1.334a2.083 2.083 0 0 1-.083-4.165V6a.75.75 0 0 1 1.5 0v.583Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17h1c.333 0 1 .2 1 1v3c0 .333-.2 1-1 1H4c-.8 0-1-.667-1-1v-3c0-.8.667-1 1-1h1m13 2.5H6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgDepositsSolid;